var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoWDol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40,22.5c0,9.66-7.84,17.5-17.5,17.5-9.66,0-17.5-7.84-17.5-17.5,0-9.66,7.84-17.5,17.5-17.5,9.66,0,17.5,7.84,17.5,17.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.51,20.68l-8.3,8.3c-.2.2-.45.29-.71.29s-.51-.1-.71-.29l-8.3-8.3c-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0l7.59,7.59,7.59-7.59c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41Z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWDol);
export default __webpack_public_path__ + "static/media/ico-w-dol.1a679c24b3cf49473b9a61b8381c9267.svg";
export { ForwardRef as ReactComponent };